module.exports = __webpack_public_path__ + "static/ctg-alumni-map-8d303aa7dcd04f92f26a8ef333dd9262.jpg";